<div class="flex flex-col gap-2">
  @for(alert of alerts$ | async; track alert.id) {
  <et-notifications-alert
    @alertAnimation
    [alert]="alert"
  ></et-notifications-alert>
  }
</div>
